import { useEffect, useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TacticalDashboard from "./components/TacticalDashboard";
import AnalysisDashboard from "./components/AnalysisDashboard";
import { TacticsData, TacticScale, PopupData, Tactics, TacticStat } from "./types/data";
import { team_configs, tactical_analysis } from "./router/resources/data";
import { getGamePrediction, getMetricString, createDisplayData } from "./router/resources/utils";
import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";

import Image1 from './images/Group 1.png'
import Image2 from './images/Group 2.png'
import Image3 from './images/Group 3.png'
import Image4 from './images/Group 4.png'
import Image5 from './images/Group 5.png'
import Image6 from './images/Group 6.png'
import Image7 from './images/Group 7.png'
import Image8 from './images/Group 8.png'

function App() {
  const [dashboardMode, setDashboardMode] = useState(0); // 0 is for prediction mode, 1 is for analysis mode
  const [open, setOpen] = useState(false)
  const [slide, setSlide] = useState(0)
  const [tacticsData, setTacticsData] = useState<TacticsData>({
    home: {
      transition: {
        efficiency: 0.0,
        usage: 0.0,
      },
      "on ball screen outside": {
        efficiency: 0.0,
        usage: 0.0,
      },
      "off ball screen outside": {
        efficiency: 0.0,
        usage: 0.0,
      },
      "on ball screen inside": {
        efficiency: 0.0,
        usage: 0.0,
      },
      "off ball screen inside": {
        efficiency: 0.0,
        usage: 0.0,
      },
      isolation: {
        efficiency: 0.0,
        usage: 0.0,
      },
    },
    away: {
      transition: {
        efficiency: 0.0,
        usage: 0.0,
      },
      "on ball screen outside": {
        efficiency: 0.0,
        usage: 0.0,
      },
      "off ball screen outside": {
        efficiency: 0.0,
        usage: 0.0,
      },
      "on ball screen inside": {
        efficiency: 0.0,
        usage: 0.0,
      },
      "off ball screen inside": {
        efficiency: 0.0,
        usage: 0.0,
      },
      isolation: {
        efficiency: 0.0,
        usage: 0.0,
      },
    },
  });

  const [defaultData, setDefaultData] = useState<TacticsData>({
    home: {
      transition: {
        efficiency: -1,
        usage: -1,
      },
      "on ball screen outside": {
        efficiency: -1,
        usage: -1,
      },
      "off ball screen outside": {
        efficiency: -1,
        usage: -1,
      },
      "on ball screen inside": {
        efficiency: -1,
        usage: -1,
      },
      "off ball screen inside": {
        efficiency: -1,
        usage: -1,
      },
      isolation: {
        efficiency: -1,
        usage: -1,
      },
    },
    away: {
      transition: {
        efficiency: -1,
        usage: -1,
      },
      "on ball screen outside": {
        efficiency: -1,
        usage: -1,
      },
      "off ball screen outside": {
        efficiency: -1,
        usage: -1,
      },
      "on ball screen inside": {
        efficiency: -1,
        usage: -1,
      },
      "off ball screen inside": {
        efficiency: -1,
        usage: -1,
      },
      isolation: {
        efficiency: -1,
        usage: -1,
      },
    },
  });

  const [awayTeam, setAwayTeam] = useState(1);
  const [homeTeam, setHomeTeam] = useState(0);
  const [homeWin, setHomeWin] = useState<number>(50);
  const [awayWin, setAwayWin] = useState<number>(50);

  const [scales, setScales] = useState<TacticScale>({
    transition: {
      efficiency: {
        min: 0,
        max: 0,
      },
      usage: {
        min: 0,
        max: 0,
      },
    },
    isolation: {
      efficiency: {
        min: 0,
        max: 0,
      },
      usage: {
        min: 0,
        max: 0,
      },
    },
    "off ball screen inside": {
      efficiency: {
        min: 0,
        max: 0,
      },
      usage: {
        min: 0,
        max: 0,
      },
    },
    "off ball screen outside": {
      efficiency: {
        min: 0,
        max: 0,
      },
      usage: {
        min: 0,
        max: 0,
      },
    },
    "on ball screen inside": {
      efficiency: {
        min: 0,
        max: 0,
      },
      usage: {
        min: 0,
        max: 0,
      },
    },
    "on ball screen outside": {
      efficiency: {
        min: 0,
        max: 0,
      },
      usage: {
        min: 0,
        max: 0,
      },
    },
  });

  const handleGamePrediction = async () => {
    getGamePrediction(tacticsData).then((val) => {
      setAwayWin(val[1]);
      setHomeWin(val[0]);
    })
  }

  useEffect(() => {
    const storedTut = localStorage.getItem('seen_tutorial');
    // if the user has not seen the tutorial, open it

    if (storedTut === null || storedTut === "false") {
      setOpen(true)
    }

    const fetchData = async () => {
      const data = await team_configs({
        home_team_id: homeTeam,
        away_team_id: awayTeam,
      });
      setTacticsData(data);
      setDefaultData(JSON.parse(JSON.stringify(data)));
      return data;
    };
    fetchData().then((data) => {
      getGamePrediction(data).then((val) => {
        setHomeWin(val[0]);
        setAwayWin(val[1]);
      });
    });
  }, [homeTeam, awayTeam]);

  useEffect(() => {
    localStorage.setItem('seen_tutorial', "true")
  }
  , [open])




  useEffect(() => {
    const fetchScales = async () => {
      const newScales = { ...scales };

      const tactics: (keyof TacticScale)[] = [
        "transition" as keyof TacticScale,
        "on ball screen outside" as keyof TacticScale,
        "on ball screen inside" as keyof TacticScale,
        "off ball screen outside" as keyof TacticScale,
        "off ball screen inside" as keyof TacticScale,
        "isolation" as keyof TacticScale,
      ];

      for (let i = 0; i < tactics.length; i++) {
        const data: PopupData = await tactical_analysis({
          team: 0,
          side: "home",
          tactical_situation: getMetricString(tactics[i] as Tactics),
          type: "efficiency",
        });
        newScales[tactics[i]].efficiency.max = data.league.max;
        newScales[tactics[i]].efficiency.min = data.league.min;

        const data2: PopupData = await tactical_analysis({
          team: 0,
          side: "home",
          tactical_situation: getMetricString(tactics[i] as Tactics),
          type: "usage",
        });
        newScales[tactics[i]].usage.max = data2.league.max;
        newScales[tactics[i]].usage.min = data2.league.min;
      }

      setScales(newScales);
    };

    const fetchData = async () => {
      const data = await team_configs({
        home_team_id: homeTeam,
        away_team_id: awayTeam,
      });
      setTacticsData(data);
      setDefaultData(JSON.parse(JSON.stringify(data)));
      return data;
    };

    fetchScales().then(() =>
      fetchData().then((data) => {
        getGamePrediction(data).then((val) => {
          setHomeWin(val[0]);
          setAwayWin(val[1]);
        });
      })
    );
  }, []);

  const runModal = () => {
    setOpen(false)
  }

  const slides = [
    {
      title: 'WELCOME',
      image: Image1,
      description: 'In order to start the analysis you need to select which teams you want to compare. You can do this by selecting the teams from the dropdowns on the top of the page. First start by selecting the home team',
    },
    {
      title: 'Finalize team selection',
      image: Image2,
      description: 'After selecting the home team, you can now select the away team. Once you have selected both teams, the page will automatically update to show the comparison between the two teams.',
    },
    {
      title: 'Calculate the game prediction',
      image: Image3,
      description: 'By clicking on the "Make Prediction" button, the page will calculate the probability of each team winning the game. The tactic scores are shown in the table to the left and the winning probabilities are shown in the pie chart to the right.',
    },
    {
      title: 'Analysis Mode',
      image: Image4,
      description: 'By clicking the toggle button on the top right of the page, you can switch to the analysis mode. In this mode, you can see the tactic scores for each team as before, but now you can also see the counterfactual tactic scores for each team.',
    },
    {
      title: 'Lock some socres',
      image: Image5,
      description: 'If you wish to make specific aspects of your or your opponets game plan unchangeable, you can lock the tactic scores by clicking on the lock icon next to the tactic score. This will make the tactic score unchangeable when calculating the game prediction.',
    },
    {
      title: 'Experiment with wanted probabilities',
      image: Image6,
      description: 'Input the desired winning probabilities for each team in the input fields. The input fields will automatically update the other input field to make sure the sum of the probabilities is 100%.',
    },
    {
      title: 'Finalize the analysis',
      image: Image7,
      description: 'By clicking "Generate Strategies" the page will calculate the counterfactual tactic scores for each team. The counterfactual tactic scores are shown in the table to the left.',
    },
    {
      title: 'Scroll through different analysis',
      image: Image8,
      description: 'By clicking next or previous you can scroll through the different counterfactual tactic scores. The counterfactual tactic scores are shown in the table to the left.'
    }
  ]


  return (
    // modal
  
      <div className="App font-roboto min-h-screen flex flex-col justify-between">
      {
        open? <div className="fixed inset-0 z-10 bg-black bg-opacity-50 absolute flex items-center justify-center">
          <div className="bg-white p-4 rounded-lg h-2/3 w-2/3 flex flex-col items-center justify-between py-12 px-12">
              <h1 className="text-3xl font-bold">{slides[slide].title}</h1>
              <img src={slides[slide].image} alt={slides[slide].title} />
              <p className="w-2/3">{slides[slide].description}</p>
              <div className="flex justify-between items-center w-2/3">
                <button onClick={() => setSlide(slide - 1)} disabled={slide === 0}
                aria-disabled={slide === 0}
                className={slide === 0 ? "flex items-center text-gray-400" : "flex items-center"}
                ><FaChevronLeft className="mr-2" /> Previous</button>
                {
                  slide === slides.length - 1 ? <button onClick={runModal} className="flex items-center text-green-400">Close</button> :                 <button onClick={() => setSlide(slide + 1)} disabled={slide === slides.length - 1}
                  className={slide === slides.length - 1 ? "flex items-center text-green-400" : "flex items-center"}
                  >
                    Next <FaChevronRight className="ml-2" />
                    </button>
                }

            </div>

        </div>
      </div> : null
      }
      <Header
        setDashboardMode={setDashboardMode}
        dashboardMode={dashboardMode}
      />
      <div className="w-full container mx-auto h-full">
      {dashboardMode === 0 && (
        <TacticalDashboard
          tacticsData={tacticsData}
          defaultData={defaultData}
          homeTeam={homeTeam}
          awayTeam={awayTeam}
          homeWin={Number(homeWin.toFixed(2))}
          awayWin={Number(awayWin.toFixed(2))}
          handleTacticsData={setTacticsData}
          changeAwayTeam={setAwayTeam}
          changeHomeTeam={setHomeTeam}
          scales={scales}
          changeGamePrediction={handleGamePrediction}
        ></TacticalDashboard>
      )}
      {dashboardMode === 1 && (
        <AnalysisDashboard
          tacticsData={createDisplayData(tacticsData)}
          defaultData={defaultData}
          homeTeam={homeTeam}
          awayTeam={awayTeam}
          scales={scales}
          homeWin={Number(homeWin.toFixed(2))}
          awayWin={Number(awayWin.toFixed(2))}
          handleTacticsData={setTacticsData}
          changeAwayTeam={setAwayTeam}
          changeHomeTeam={setHomeTeam}
        ></AnalysisDashboard> 
      )}
      </div>
      <Footer />
    </div>
  );
}

export default App;
